var map = {
	"./upload_wall_1.webp": "0929",
	"./upload_wall_2.webp": "41ec",
	"./upload_wall_3.webp": "7e4d",
	"./upload_wall_4.webp": "a8da",
	"./upload_wall_5.webp": "5de1",
	"./upload_wall_6.webp": "02ee",
	"./upload_wall_7.webp": "7d72b",
	"./upload_wall_8.webp": "3e20"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b8da";